import { AuthLevel, generateApiPath } from '@guiker/api-definition'

export const paths = {
  notificationPreference: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'notification-preference' }),
}
